import { select, takeLatest } from 'redux-saga/effects';

import config from 'config';

import api from 'apiSingleton';

import { selectToken } from 'redux/user/selectors';
import { selectInitFrontChat } from 'redux/uiEffects/selectors';
import { INIT_FRONT_CHAT } from 'redux/uiEffects/actionTypes';
import { selectPaymentMethod } from 'redux/payment/selectors';

import { cleanObject, getLanguage } from 'helpers/utils';

import { HashedEmailResp } from 'types/user/userApiInterface';
import { GetUserResponse } from 'types/user/getUser';

import { PaymentMethod } from 'interfaces/Payments/payments';

function* frontChatInitialization() {
    const language = getLanguage();

    const shouldInitChat: boolean = yield select(selectInitFrontChat);
    const paymentMethod: PaymentMethod = yield select(selectPaymentMethod);
    const token: string = yield select(selectToken);

    try {
        if (shouldInitChat && token) {
            const response: HashedEmailResp = { data: yield api.user.hashedEmail() };

            const { email, name, country, is_paid: isPaid, product_list }: GetUserResponse = yield api.user.getUser();

            const customFields = cleanObject({
                platform: 'web',
                project: config?.AWS_DELIVERY_STREAM_NAME || 'yoga-go',
                country,
                language,
                isPaid,
                paymentType: paymentMethod,
                ...product_list,
            });

            const initData = {
                chatId: config?.FRONT_CHAT_ID,
                useDefaultLauncher: true,
                email: email?.toLowerCase(),
                name: name,
                userHash: response?.data,
                customFields: customFields,
            };

            if (!window.FrontChat) {
                const insertScript = () => {
                    const d = document;
                    const script = d.createElement('script');

                    script.type = 'text/javascript';
                    script.async = true;
                    script.src = 'https://chat-assets.frontapp.com/v1/chat.bundle.js';
                    d.body.appendChild(script);
                    script.onload = () => {
                        window.FrontChat('init', initData);
                    };
                };

                insertScript();
            }
        }
        if (window.FrontChat && !shouldInitChat) {
            window.FrontChat('shutdown');
            // @ts-ignore
            delete window.FrontChat;
        }
    } catch (e) {
        console.error('chat error', e);
    }
}

export const frontChat = [takeLatest(INIT_FRONT_CHAT, frontChatInitialization)];
